module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "site-header header-one home-page-one sp-gw-head"
  }, [_c('c-settings'), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "logo-box clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "menu-toggler",
    on: {
      "click": _vm.display_menu
    }
  }, [_c('span', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main-navigation",
    attrs: {
      "id": "main-nav-bar"
    }
  }, [_c('ul', {
    staticClass: "one-page-scroll-menu navigation-box"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "gw-mobile"
  }, [(!_vm.loggedIn) ? _c('a', {
    staticClass: "gw-mobile",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]) : _c('a', {
    staticClass: "gw-mobile",
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("Manage")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right-side-box"
  }, [(!_vm.loggedIn) ? _c('a', {
    staticClass: "header-btn",
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Login")]) : _c('a', {
    staticClass: "header-btn",
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("Manage")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": "Gallery"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('a', {
    attrs: {
      "href": "/demos"
    }
  }, [_vm._v("Demos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('a', {
    attrs: {
      "href": "/go/features"
    }
  }, [_vm._v("Features")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {}, [_c('a', {
    attrs: {
      "href": "/go/pricing"
    }
  }, [_vm._v("Pricing")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ff4094"}!./src/pages/MainHeader/template.html
// module id = 245
// module chunks = 0